import { render, staticRenderFns } from "./WriteCenter.vue?vue&type=template&id=47bf2d32&scoped=true&"
import script from "./WriteCenter.vue?vue&type=script&lang=js&"
export * from "./WriteCenter.vue?vue&type=script&lang=js&"
import style0 from "./WriteCenter.vue?vue&type=style&index=0&id=47bf2d32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bf2d32",
  null
  
)

export default component.exports